const getPrice = (values, userData, oldprice) => {
  let price = oldprice;
  if (values.type === "limit" &&
  parseInt(userData[values.field]) >= values.min &&
  parseInt(userData[values.field]) <= values.max) {
   price = values.packagePrice
  }
  else if (values.type === "userData") {
    if(userData[values.field] && 
      (userData[values.field] === values.value) ||
      userData[values.field] !== values.notValue){
      price = values.packagePrice;
    }
  }
  return price;
}

export const getProductPrice = (product, userData) => {
  const priceList = userData.staticQuotes;
  const productDetails = priceList[product];
  let price = 0;
  const coveragePriceLength = productDetails.coveragePrice.length;

  if (coveragePriceLength === 1) {
    price = productDetails.coveragePrice[0].packagePrice;
  }
  else if (coveragePriceLength > 1) {
    productDetails.coveragePrice.map(item => {
      price = getPrice(item, userData, price);
    })
  }
  return price;
}

export const getCoverageCodes = (product, userData) => {
  const priceList = userData.staticQuotes;
  const productDetails = priceList[product];
  const coveragePriceLength = productDetails.coveragePrice.length;
  let coverages = [];

  if (coveragePriceLength === 1) {
    coverages = productDetails.coveragePrice[0].coverageCodes;
  }
  else if (coveragePriceLength > 1) {
    productDetails.coveragePrice.map(item => {
      if (item.type === "limit" &&
      parseInt(userData[item.field]) >= item.min &&
      parseInt(userData[item.field]) <= item.max) {
        coverages = item.coverageCodes;
      }
      else if (item.type === "userData") {
        if(userData[item.field] && 
          (userData[item.field] === item.value) ||
          userData[item.field] !== item.notValue){
            coverages = item.coverageCodes;
        }
      }
    })
  }
  return coverages;
}

export const getCoveragePrice = (coverages, userData) => {
  let aprice = 0;
  if(coverages.length === 1) {
    aprice = coverages[0].packagePrice;
  }
  else {
    coverages.map((cov) => {
      aprice = getPrice(cov, userData, aprice);
    })
  }
  return aprice;
}

export const getMaxDecimalPlaces = (...nums) => {
  const decimals = []
  nums.forEach((num) => {
    const str = num.toString();
    if (str.includes('.')) {
      decimals.push(str.split('.')[1].length);
    } 
  })
  if (decimals.length === 0) {
    return 0
  }
  return Math.max(...decimals);
}